import { Controller, useFormContext } from 'react-hook-form';

import { FileUploadInput } from '@ui/components/FileUploadInput';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

type Props = {
  onUpload: (formData: FormData) => Promise<unknown>;
};
export function LogoInput({ onUpload }: Props) {
  const { control } = useFormContext<{ logoUrl?: string | null }>();
  return (
    <FormRow>
      <FormLabel>Логотип</FormLabel>
      <FormInput>
        <Controller
          name="logoUrl"
          control={control}
          render={({ field: { value, disabled } }) => (
            <FileUploadInput
              description="SVG, до 2 МБ"
              value={value}
              onChange={onUpload}
              showPreview
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
